// extracted by mini-css-extract-plugin
export default {"notificationsStroke":"jawQ4r","notificationsFill":"flXcGt"};